<script setup>
// import api from "../api/api";
</script>

<template>
  <div class="main-survey-box">
    <div>
      <iframe
        :src="`${passedRouteParams.surveyTemplateLink}?survey_assignment_id=${passedRouteParams.surveyAssignmentLink}&ind_id=${passedRouteParams.indId}&org_id=${passedRouteParams.orgId}&subOrg_id=${passedRouteParams.suborgId}&first_name=${userData.first_name}&last_name=${userData.last_name}&rand=${rand}&iteration_id=${passedRouteParams.iteartionId}&survey_template_id=${passedRouteParams.surveyTemplateId}&run_mode=${passedRouteParams.runMode}`"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
/* global Weglot */
export default {
  component: [],
  props: {
    userData: Object,
    brandData: Object,
  },
  data: () => ({
    passedRouteParams: {},
    rand: "",
    surveyOpenStatus: null,
    prepolulateEndpoint: "",
    surveyVersion: null,
    prepopulateData: [],
  }),
  async mounted() {
    this.passedRouteParams = JSON.parse(this.$route.params.data)
    console.log(this.passedRouteParams)
    this.rand = Math.random()

    // Send language to survey iframe via postMessage
    const lang = (window.Weglot && Weglot.getCurrentLang && Weglot.getCurrentLang()) || 'en';
    if (lang && lang !== 'en') {
      this.$nextTick(() => {
        const iframe = this.$el.querySelector('iframe');
        if (iframe) {
          iframe.addEventListener('load', () => {
            console.log('[MySurvey] Sending SET_LANGUAGE postMessage to survey iframe, lang:', lang);
            iframe.contentWindow.postMessage(
              { type: 'SET_LANGUAGE', lang: lang },
              window.location.origin
            );
            console.log('[MySurvey] postMessage sent');
          });
        }
      });
    }
  },
  unmounted() {
    this.$emit("passHeaderSubjectFullName", "");
  },
};
</script>

<style scoped>
iframe {
  width: 100%;
  height: 78vh;
  overflow: hidden;
  margin: 5px 0;
}
</style>
